import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Children, Component, Fragment } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  background: #fff;
  position: fixed;
  top: 0;
  width: calc(100% - 3.5rem);
  height: 100%;
  max-width: 28rem;
  z-index: ${props => props.open ? '500' : '300'};
  transition: all 0.3s;
`

const LeftBox = styled(Box)`
  left: 0;
  border-right: 1px solid var(--light-gray);
  transform: ${props => props.open ? 'translate(0, 0)' : 'translate(-100%, 0)'};
`

const RightBox = styled(Box)`
  right: 0;
  border-left: 1px solid var(--light-gray);
  transform: ${props => props.open ? 'translate(0, 0)' : 'translate(100%, 0)'};
`

const LeftMenuButton = styled.div`
  display: block;
  position: fixed;
  width: 3.5rem;
  height: 3.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gray);
  background: transparent;
  font-size: 1.5rem;
  z-index: 300;
  left: 100%;
  &:hover {
    color: var(--dark-gray);
  }
`

const RightMenuButton = styled(LeftMenuButton)`
  left: -3.5rem;
`

const Underlay = styled.div`
  position: fixed;
  width: 100%;
  height: ${props => props.open ? '100%' : '0'};
  background: rgba(240, 240, 240, 0.7);
  backdrop-filter: saturate(180%) blur(10px);
  z-index: 400;
  cursor: pointer;
  opacity: ${props => props.open ? '1' : '0'};
  transition-property: height, opacity;
  transition-duration: 0s, 0.3s;
  transition-delay: ${props => props.open ? '0s' : '0.3s'}, 0s;
`

const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  &>* {
    flex-shrink: 0;
  }
`

@observer
export default class Menu extends Component {
  @observable open = false

  @action
  toggle = () => {
    const { keepMenuOpen } = this.props
    if (!keepMenuOpen) {
      this.open = !this.open
    }
  }

  renderChildren = () => {
    const { children } = this.props

    return Children.map(children, child => {
      if (child) {
        return React.cloneElement(child, { onCloseMenu: this.toggle })
      } else {
        return child
      }
    })
  }

  render() {
    const { right, icon } = this.props
    const ChosenBox = right ? RightBox : LeftBox
    const ChosenMenuButton = right ? RightMenuButton : LeftMenuButton
    
    return (
      <Fragment>
        <ChosenBox open={this.open}>
          <ChosenMenuButton
            className={(
              (this.open && 'fas fa-times') ||
              icon
            )}
            onClick={this.toggle}
          />
          <Content>
            {this.renderChildren()}
          </Content>
        </ChosenBox>
        <Underlay open={this.open} onClick={this.toggle} />
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js